import ReportsFilters from './ReportsFilters';
import KpiCards from './KpiCards';
import SimpleChart from './SimpleChart';
import ReportTable from './ReportTable';
import { formatNumber, formatPercent } from './formatters';

const OccupancyReports = ({
  data,
  filters,
  onFiltersChange,
  onApply,
  onExport,
  loading,
  exporting,
  properties = [],
  hosts = [],
  showHost = false,
  loadingMeta = false,
}) => {
  const kpis = data?.kpis || {};
  return (
    <div className="space-y-4">
      <ReportsFilters
        filters={filters}
        onChange={onFiltersChange}
        onApply={onApply}
        onExport={onExport}
        properties={properties}
        hosts={hosts}
        showHost={showHost}
        showProperty
        showGroupBy
        loadingMeta={loadingMeta}
        applying={loading}
        exporting={exporting}
      />

      <KpiCards
        items={[
          { label: 'Booked nights', value: kpis.bookedNights, render: (v) => formatNumber(v) },
          { label: 'Available nights', value: kpis.availableNights, render: (v) => formatNumber(v) },
          { label: 'Blocked nights', value: kpis.blockedNights, render: (v) => formatNumber(v) },
          { label: 'Occupancy rate', value: kpis.occupancyRate, render: (v) => formatPercent(v) },
        ]}
      />

      <SimpleChart
        data={data?.timeseries || []}
        series={[
          { key: 'occupancyRate', label: 'Occupancy %', color: '#0ea5e9' },
          { key: 'bookedNights', label: 'Booked nights', color: '#22c55e' },
        ]}
      />

      <ReportTable
        loading={loading}
        columns={[
          { key: 'period', label: 'Period' },
          { key: 'bookedNights', label: 'Booked', render: formatNumber },
          { key: 'availableNights', label: 'Available', render: formatNumber },
          { key: 'blockedNights', label: 'Blocked', render: formatNumber },
          { key: 'occupancyRate', label: 'Occupancy', render: (v) => formatPercent(v) },
        ]}
        rows={(data?.timeseries || []).map((row) => ({
          ...row,
          period: row.period?.slice(0, 10),
        }))}
        emptyText="No occupancy data in this range."
      />
    </div>
  );
};

export default OccupancyReports;
